import { useEffect, useState } from "react";
import { findEntityData, findImage } from "../../api/apiService";

const MissionAndVision = () => {
    const [section1, setSection1] = useState();
    const [imageUrls, setImageUrls] = useState([]);

    const findData = async () => {
        const res = await findEntityData("sss_about_mission_vision");
        setSection1(res?.data?.[0]);
    };

    const renderImage = async (id) => {
        if (!id) return null;
        const res = await findImage(id);
        return res?.data?.url;
    };

    useEffect(() => {
        findData();
    }, []);

    useEffect(() => {
        // fetch all image URLs when section1 data changes
        const fetchImages = async () => {
            if (!section1?.data) return;
            const urls = await Promise.all(
                section1.data.map(async (item) => {
                    const url = await renderImage(item?.img);
                    return url;
                })
            );
            setImageUrls(urls);
        };

        fetchImages();
    }, [section1]);

    return (
        <section
            id={section1?.sectionName}
            className="max-w-4xl mx-auto flex flex-col space-y-12 sm:space-y-16 my-12 sm:my-16"
        >
            {section1?.data?.map((item, index) => (
                <div
                    key={index}
                    className="relative flex justify-center items-center px-6 sm:px-0"
                >
                    {/* Left-aligned label */}
                    {index % 2 === 0 && (
                        <span className="absolute left-2 sm:left-0 bg-[#F37934] font-cinzel text-white px-1 sm:px-2 py-6 sm:py-10 font-semibold writing-vertical rotate-180 text-xs sm:text-sm md:text-base">
                            {item?.heading}
                        </span>
                    )}

                    {/* Main content */}
                    <div className="flex flex-col items-center space-y-4 text-center">
                        <img
                            src={
                                imageUrls[index]
                            }
                            alt={item?.alt || "Image"}
                            className="w-24 h-24 sm:w-32 sm:h-32 p-2 sm:p-4 mx-auto object-cover"
                        />
                        <p className="text-base sm:text-lg font-semibold max-w-xs">
                            {item?.content}
                        </p>
                    </div>

                    {/* Right-aligned label */}
                    {index % 2 === 1 && (
                        <span className="absolute right-2 sm:right-0 bg-[#F37934] font-cinzel text-white px-1 sm:px-2 py-6 sm:py-10 font-semibold writing-vertical text-xs sm:text-sm md:text-base">
                            {item?.heading}
                        </span>
                    )}
                </div>
            ))}
        </section>
    );
};

export default MissionAndVision;
